export default __webpack_public_path__ + "static/media/009-vodka.522a93e8.svg";